import type { AccountNumber } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, post } from './request';

export const FAVORITE_ACCOUNT_SERVICE_PATH = 'rest/resource/favoriteaccount';

export async function getFavoriteAccount(): Promise<AccountNumber | undefined> {
    return get(`${CONTEXT_PATH}/${FAVORITE_ACCOUNT_SERVICE_PATH}`);
}

export async function saveFavoriteAccount(accountNumber: AccountNumber): Promise<void> {
    await post<unknown>(`${CONTEXT_PATH}/${FAVORITE_ACCOUNT_SERVICE_PATH}/`, accountNumber);
}
